import React from "react";
import { animated, useSpring } from "react-spring";
import styled from "styled-components";
import Paper from "../../ui-library/Paper/Paper";

const StyledAnimatedDiv = styled(animated.div)`
  display: inline;

  @media only screen and (max-width: 760px),
    (min-device-width: 768px) and (max-device-width: 1024px) {
    display: none;
  }
`;

const CardIcon = (props) => {
  const { className, iconAccent } = props;

  const animatedProps = useSpring({
    width: 80,
    height: 80,
    scale: 1,
    fontSize: 50,
    from: {
      scale: 0.25,
    },
    config: {
      mass: 1,
      tension: 400,
      friction: 10,
    },
  });

  return (
    <StyledAnimatedDiv
      className={`${iconAccent ?? "icon-accent"} icon-lg icon-card text-center`}
      style={animatedProps}
      data-testid={props["data-testid"]}
    >
      <i
        className={`${className}`}
        style={{ marginTop: "0.90rem" }}
        data-testid={props["data-testid"] + "-i"}
      />
    </StyledAnimatedDiv>
  );
};

const CardBody = styled.div`
  @media only screen and (max-width: 760px),
    (min-device-width: 768px) and (max-device-width: 1024px) {
    padding: 0;
  }
`;

export const ProfileCard = (props) => {
  const {
    showIcon = true,
    iconClassName,
    title,
    children,
    cardHeader,
    ultraShadow,
    iconAccent,
    isRound = false,
    removePadding = false,
    image = "",
    hasSeparator,
  } = props;
  return (
    <Paper
      header={title}
      ultraShadow={ultraShadow}
      cardHeader={cardHeader}
      className="card mb-4 shadow-rarify profile-card h-100"
      isRound={isRound}
      image={image}
      hasSeparator={hasSeparator}
    >
      {showIcon && (
        <CardIcon
          className={iconClassName}
          iconAccent={iconAccent}
          data-testid="test-card-icon"
        />
      )}
      <CardBody className={`${removePadding ? "" : "card-body"} smallscroll`}>
        {children}
      </CardBody>
    </Paper>
  );
};
